import { render, staticRenderFns } from "./FraudStatusColumn.vue?vue&type=template&id=3836962a&"
import script from "./FraudStatusColumn.vue?vue&type=script&lang=ts&"
export * from "./FraudStatusColumn.vue?vue&type=script&lang=ts&"
import style0 from "./FraudStatusColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports